package com.example.mystybag.login.model

enum class LoginDetailsRequiredField {
    EMAIL,
    PASSWORD,
    CONFIRM_PASSWORD
}

data class MerchantRegistrationAddLoginDetailsUIState(
    val email: String = "",
    val password: String = "",
    val confirmPassword: String = "",
    val passwordVisible: Boolean = false,
    val confirmPasswordVisible: Boolean = false,
    val passwordRequirements: PasswordRequirements = PasswordRequirements(),
    val isLoading: Boolean = false,
    val requiredFieldErrors: Set<LoginDetailsRequiredField> = emptySet()
)

data class PasswordRequirements(
    val hasMinLength: Boolean = false,
    val hasNumber: Boolean = false,
    val hasLetter: Boolean = false
) {
    val isValid: Boolean
        get() = hasMinLength && hasNumber && hasLetter
}

